import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { StyleService } from '../../../../infrastructure/services/style.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSmartModalService } from 'ngx-smart-modal';
import {
  JsonEditorOptions,
  JsonEditorComponent,
} from 'angular4-jsoneditor/jsoneditor/jsoneditor.component';
import { Subscription } from 'rxjs/Subscription';

// Servicios
import { DragulaService } from 'ng2-dragula';
import {
  AlertService,
  GrowlType,
} from '../../../../infrastructure/services/alert.service';
import { LoaderService } from '../../../../infrastructure/services/loader.service';
import { SxRouterService } from '../../../../infrastructure/services/sxRouter.service';
import { SxfDesignerService } from '../../services/sxfdesigner-service';

// Componentes
import { BaseDesignerComponent } from '../designers/base/base-designer-component';
import { SxMainContainer } from './main-container.component';

// Types
import { DesignerContextType } from '../../types/designer-context-type';
import {
  ProductType,
  PageType,
  DesignerSelectItem,
} from '../../types/product.type';
import { ProductDesignType } from '../../types/product-design.type';
import { LayoutType } from '../../types/layout-type';
import { ControlSourceType } from '../../types/control-source.type';
import { SxCustomControl } from '../designers/custom/custom-control-designer.component';
import { SxfPageDesignerService } from '../../services/page-service';
import { CompleteDesignerContext, NonTransLayout, SxDocumentTypes } from './completeContext';
import { ProductFlowService } from 'app/infrastructure/services/productFlow.service';
import { CacheService } from 'app/infrastructure/services/cache.service';
import { SxConfigModalComponent } from '../modals/config-modal.component';
import { SxDesignerMenuComponent } from './designer.menu.component';
import { SxInternalStateDesignerService } from '../../services/internal-state-designer-service';
import { ViewEngine } from '../../types/view-engine.interface';
import { NonTransactionalFlowService } from 'app/infrastructure/services/non-transactional-flow.service';

@Component({
  templateUrl: './designer.component.html',
})
export class SxDesigner implements OnDestroy, OnInit {
  selected = 'defaultPanel';
  editorOptions: JsonEditorOptions;
  customAtributosUsados = [];
  activeTab: 'General';

  selectConfig = {
    // if objects array passed which key to be displayed defaults to description
    displayKey: 'description',
    search: true,
    limitTo: 4,
  };

  codsistema: string;
  codnegocio: string;
  codproducto: string;
  codservicio: string;
  codcomando: string;
  documentKind: string;
  flowId: string;
  pageId: string;
  listPath: string;

  isNonTransactional: boolean;

  // Referencia al editor de json
  @ViewChild(JsonEditorComponent) jsonEditor: JsonEditorComponent;

  // Referencia al designer principal
  @ViewChild('mainContainer')
  private mainContainer: SxMainContainer;

  @ViewChild('configModal')
  private configModal: SxConfigModalComponent;

  @ViewChild('designerMenu')
  private designerMenu: SxDesignerMenuComponent;

  // Contexto del designer.
  designerContext: DesignerContextType;

  searchAtt: String = '';
  attFiltered: any[];
  veFiltered: any[];
  viewEngines: ViewEngine[];

  // Suscripciones
  private subscriptions: { [id: string]: Subscription } = {};
  private showAttributes: boolean;

  completeContext: CompleteDesignerContext = {
    codsistema: '',
    codnegocio: '',
    codproducto: '',
    codservicio: '',
    codcomando: '',
    documentKind: '',
    flowId: '',
    pageId: '',
    listPath: '',
  };

  ControlSourceType: typeof ControlSourceType = ControlSourceType;

  // To remove the menu
  lastActiveDesigner: any;

  // Search Inputs
  styleCSS: String = '';
  styleClasses = '';

  // Navigator helper
  designerChilds = [];
  isFirstCounter = 0;
  firstEntrance = false;

  constructor(
    private styleService: StyleService,
    private activatedRoute: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private dragulaService: DragulaService,
    public ngxSmartModalService: NgxSmartModalService,
    private formularioDinamicoService: SxfDesignerService,
    private pageService: SxfPageDesignerService,
    private alertService: AlertService,
    private sxRouter: SxRouterService,
    private router: Router,
    public flowService: ProductFlowService,
    private cacheService: CacheService,
    public loader: LoaderService,
    public internalState: SxInternalStateDesignerService,
    private nonTransactionalSrv: NonTransactionalFlowService
  ) {
    // JsonEditor options
    this.editorOptions = new JsonEditorOptions();
    this.editorOptions.modes = ['code', 'text', 'tree', 'view'];

    // Configuramos Dragula
    dragulaService.setOptions('designer-bag', this.getOpcionesDragula());

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.initializer();
  }

  ngOnInit() {
    document
      .getElementById('container-principal')
      .classList.remove('container');
    this.styleService.addStyle('designer', require('./designer.component.css'));
  }

  initializer() {
    this.isNonTransactional = this.router.url.includes('nontransactionalflows');
    this.activatedRoute.params.subscribe((params) => {
      this.inicializarContexto(params);
      this.obtenerFormularioDinamico();
    });
  }

  ngOnDestroy(): void {
    this.styleService.removeStyle('designer');
    this.dragulaService.destroy('designer-bag');

    // Limpio el contexto
    for (const key in this.subscriptions) {
      const subscription = this.subscriptions[key];
      if (subscription) {
        subscription.unsubscribe();
      }
    }

    for (const key in this.designerContext.designers) {
      let designer = this.designerContext.designers[key];
      if (designer) {
        designer.destroy();
        designer = null;
      }
    }

    this.designerContext.selectedDesigner = null;
    this.designerContext.selectedDesignerAtts = null;
    this.designerContext = null;
  }

  // adds the simple references to the product and stores the
  // atribute names
  getProductServiceSuccess(data: ProductDesignType): void {
    this.designerContext.externalControls = data.formControls;
    this.designerContext.product.attributeCodes = [];
    data.formControls.forEach((el) => {
      const flAttr = {
        id: el.codAtributo,
        description: el.descripcion,
      };
      this.designerContext.product.attributeCodes.push(flAttr);
    });

    sessionStorage.externalControls = JSON.stringify(data.formControls);
    this.filterAttr();
  }

  // Cuando se agrega un control a la coleccion me atacho a sus eventos.
  designerAdded(designer: BaseDesignerComponent): void {
    if (!designer) {
      return;
    }

    // Se termino de crear el designer
    this.subscriptions[
      designer.id + '_created'
    ] = designer.created.subscribe((d) => this.designerCreated(d));
    this.subscriptions[
      designer.id + '_destroying'
    ] = designer.destroying.subscribe((d) => this.designerDestroying(d));

    // Se fija si se entra por primera vez el desginer
    let firstDesigner = this.firstEntranceCondition(designer);

    if (this.designerContext.designerLoaded) {
      // muestro el menu del designer que se añadió
      if (!this.firstEntrance || !firstDesigner) {
        this.designerMenu.designerShowMenu(designer);
        if (designer.type === 'SxViewEngine') {
          this.ngxSmartModalService.setModalData({}, 'viewEngineModal');
          this.ngxSmartModalService.getModal('viewEngineModal').open();
        } else {
          // Levanto el modal
          this.configModal.showDesignerConfig();
        }
      }
    }

    // Aviso que ya termino de cargarse el designer
    if (firstDesigner) {
      this.firstEntrance = false;
    }

    // me subscribo al evento del click para mostrar el menu
    this.subscriptions[
      designer.id + '_showMenu'
    ] = designer.showMenu.subscribe((d) =>
      this.designerMenu.designerShowMenu(d)
    );
  }

  // shows the configuration when a new control is added
  designerDestroying(designer: BaseDesignerComponent): void {
    if (!designer) {
      return;
    }

    if (designer instanceof SxCustomControl) {
      const index = this.customAtributosUsados.indexOf(designer.type);
      if (index >= 0) {
        this.customAtributosUsados.splice(index, 1);
      }
    }
    // unsubscription
    this.subscriptions[designer.id + '_destroying'].unsubscribe();
    delete this.subscriptions[designer.id + '_destroying'];
    if (this.subscriptions[designer.id + '_showMenu']) {
      this.subscriptions[designer.id + '_showMenu'].unsubscribe();
      delete this.subscriptions[designer.id + '_showMenu'];
    }
  }

  // shows the configuration when a new control is added
  designerCreated(designer: BaseDesignerComponent): void {
    if (!designer) {
      return;
    }

    if (designer instanceof SxCustomControl) {
      this.customAtributosUsados.push(designer.type);
    }

    // unsuscribe
    this.subscriptions[designer.id + '_created'].unsubscribe();
    delete this.subscriptions[designer.id + '_created'];

    this.designerMenu.designerShowMenu(designer);
    this.cdRef.detectChanges();
    if (this.showAttributes) {
      this.configModal.showDesignerConfig();
    }
  }

  // loads the designer of configuration of a pre existing layout
  cargarDesigner(product: any): void {
    this.designerContext.product = {
      ...this.designerContext.product,
      ...product,
    };
    this.designerContext.isNonTransactional = this.isNonTransactional;

    this.isNonTransactional === true && (this.designerContext.page = false);

    if (this.designerContext.page && !product.layout.pageNumber) {
      product.layout.pageNumber = 0;
    }

    // Obtenemos el json con la configuracion del formulario dinamico
    const rootInfo = this.designerContext.product.layout.root;

    this.inicializarPanelPrincipal(
      this.designerContext.product.layout.root.title
    );
    // Se crean los designers
    this.cargarEstado(rootInfo);
  }

  /**
   * Carga el designer con el estado que representa
   * el json pasado como parametro
   */
  cargarEstado(jsonRoot) {
    this.showAttributes = false;
    // El designer principal se encarga de la carga
    if (jsonRoot) {
      this.firstCharge(jsonRoot);
      this.mainContainer.loadState(jsonRoot);
    }

    setTimeout(() => {
      this.designerContext.designerLoaded = true;
      this.showAttributes = true;
    }, 1500);
  }

  firstCharge(jsonRoot) {
    this.designerChilds = jsonRoot.childs;
    this.isFirstCounter = jsonRoot.childs.length;
    this.firstEntrance = true;
  }

  firstEntranceCondition(designer) {
    if (this.firstEntrance) {
      let index = this.designerChilds.findIndex((child) => child.id === designer.id);
      if (index !== -1) {
        this.isFirstCounter--;
      } else {
        return false;
      }
      if (this.isFirstCounter === 0) {
        return true;
      }

      return false;
    }

    return true;
  }

  // saves the layout and navigates back if asked to,
  // if ther e is a context in cache, it will navigate to that
  // instead
  guardarDesigner(navigateBack: boolean): void {
    const product = this.designerContext.product;

    if (!product.layout) {
      product.layout = new LayoutType();
    }
    if (this.selected === 'defaultPanel') {
      product.layout.root = this.mainContainer.getDesignerInfo();
    } else {
      product.layout.root = this.getJsonEditorInfo();
    }

    if (this.isNonTransactional) {
      const data = { Form: product as PageType };
      this.nonTransactionalSrv
        .createOrUpdatePage(this.flowId, data)
        .subscribe(() => {
          this.alertService.showGrowl(
            {
              type: GrowlType.SUCCESS,
              body: 'DATA_SAVED_WITH_ID',
            },
            { id: this.flowId }
          );
          if (navigateBack)
            this.router.navigate(['../../'], {
              relativeTo: this.activatedRoute,
            });
        });
        return;
    }

    // if it has some stored context at the way back it needs to navigate
    // back to that context and revmove it from storage
    const storedContext = this.cacheService.getDesignerOutputs();
    if (storedContext) {
      this.cacheService.removeDesignerOutputs();
      if (storedContext.storedContext.listPath) {
        this.pageService.save(product as PageType).then((res) => {
          this.guardadoExitoso(res);
          this.router.navigate(
            [
              '../../',
              storedContext.storedContext.pageId,
              storedContext.storedContext.listPath,
            ],
            { relativeTo: this.activatedRoute }
          );
        });
      } else {
        this.pageService.save(product as PageType).then((res) => {
          this.guardadoExitoso(res);
          this.router.navigate(['../', storedContext.storedContext.pageId], {
            relativeTo: this.activatedRoute,
          });
        });
      }
      return;
    }

    // normal operation
    if (this.designerContext.page && !this.designerContext.attrubuteList) {
      this.pageService.save(product as PageType).then((res) => {
        this.guardadoExitoso(res);
        if (navigateBack) {
          this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
        }
      });
    } else if (
      !this.designerContext.page &&
      !this.designerContext.attrubuteList
    ) {
      this.formularioDinamicoService
        .save(product as ProductType)
        .then((res) => this.guardadoExitoso(res));
    } else if (
      this.designerContext.page &&
      this.designerContext.attrubuteList
    ) {
      this.pageService
        .save(product as PageType)
        .then((res) => this.guardadoExitoso(res))
        .then((_) => {
          if (navigateBack) {
            this.router.navigate(['../../'], {
              relativeTo: this.activatedRoute,
            });
          }
        });
    } else {
      this.formularioDinamicoService
        .save(product as ProductType)
        .then((res) => this.guardadoExitoso(res))
        .then((_) => {
          if (navigateBack) {
            this.router.navigate(['../../'], {
              relativeTo: this.activatedRoute,
            });
          }
        });
    }
  }

  // shows a toast if succesful save
  guardadoExitoso(response: any): void {
    if (this.designerContext) {
      this.designerContext.product.id = response.data.id;
    }

    this.alertService.showGrowl(
      {
        type: GrowlType.SUCCESS,
        body: 'DATA_SAVED_WITH_ID',
      },
      { id: response.data.id }
    );
  }

  changingTab(event) {
    this.activeTab = event.nextId;
  }

  isValidTest(): boolean {
    return this.designerContext.product.id > 0;
  }

  loadStateFromJSONEditor() {
    this.cargarEstado(this.getJsonEditorInfo());
  }

  getDesignerInfo() {
    return this.mainContainer.getDesignerInfo();
  }

  getJsonEditorInfo() {
    return this.jsonEditor ? JSON.parse(this.jsonEditor.getText()) : '';
  }

  navigateToConsultaSimple(atrCode) {
    this.sxRouter.navigateToConfigSimpleQueryInNewTab(
      atrCode,
      this.activatedRoute
    );
  }

  private inicializarContexto(params) {
    this.flowId = params['flowId'];
    this.pageId = params['pageId'];
    this.completeContext.flowId = this.flowId;
    this.completeContext.pageId = this.pageId;

    if (!this.isNonTransactional) {
      this.codsistema = params['codsistema'];
      this.codnegocio = params['codnegocio'];
      this.codproducto = params['codproducto'];
      this.codservicio = params['codservicio'];
      this.codcomando = params['codcomando'];
      this.documentKind = params['documentKind'];
      this.listPath = params['listPath'];

      if (this.codsistema === undefined) {
        this.codsistema = '*';
        this.codnegocio = '*';
      }

      this.completeContext.codsistema = this.codsistema;
      this.completeContext.codnegocio = this.codnegocio;

      if (
        this.completeContext.codsistema === undefined &&
        this.completeContext.codnegocio === undefined
      ) {
        this.completeContext.codsistema = 'null';
        this.completeContext.codnegocio = 'null';
      }

      this.completeContext.codproducto = this.codproducto;
      this.completeContext.codservicio = this.codservicio;
      this.completeContext.codcomando = this.codcomando;

      if (this.documentKind === undefined) {
        this.completeContext.documentKind = SxDocumentTypes.None;
      } else {
        this.completeContext.documentKind = this.documentKind;
      }

      this.completeContext.listPath = this.listPath;
    }

    // we distinguish in between 4 posible cases context cases
    if (this.flowId !== undefined) {
      this.completeContext.codservicio = 'SrvDynFormEngin';
      if (this.listPath !== undefined) {
        const page = new PageType(this.flowId, this.pageId, this.listPath);
        this.designerContext = new DesignerContextType(page);
        this.designerContext.page = true;
        this.designerContext.attrubuteList = true;
      } else {
        const page = new PageType(this.flowId, this.pageId,'');
        this.designerContext = new DesignerContextType(page);
        this.designerContext.page = true;
        this.designerContext.attrubuteList = false;
      }
    } else {
      if (this.listPath !== undefined) {
        const productAttList = new ProductType(this.listPath);
        this.designerContext = new DesignerContextType(productAttList);
        this.designerContext.page = false;
        this.designerContext.attrubuteList = true;
      } else {
        const productAttList = new ProductType('');
        this.designerContext = new DesignerContextType(productAttList);
        this.designerContext.page = false;
        this.designerContext.attrubuteList = false;
      }
    }
    if (!this.isNonTransactional) {
      this.designerContext.product.name = this.codservicio + '_layout';
      this.designerContext.product.codSistema = this.completeContext.codsistema;
      this.designerContext.product.codNegocio = this.completeContext.codnegocio;
      this.designerContext.product.codProducto = this.completeContext.codproducto;
      this.designerContext.product.codComando = this.completeContext.codcomando;
      this.designerContext.product.codServicio = this.completeContext.codservicio;
      this.designerContext.product.documentKind = this.completeContext.documentKind;
      this.designerContext.product.listPath = this.completeContext.listPath;
    }
    this.designerContext.isNonTransactional = this.isNonTransactional;

    // Suscripcion al evento de agregado de controles
    this.subscriptions['designerAdded'] = this.designerContext.designerAdded.subscribe((designer) => 
      setTimeout(() => {
        this.designerAdded(designer);
      }, 1000)
    );
  }

  // Inicializacion del panel principal
  inicializarPanelPrincipal(title: string) {
    this.mainContainer.controlContext.title = title;
  }

  saveConfiguration() {
    this.configModal.okDesignerConfigurtion();
  }

  // gets the layout acording to context and if its a page,
  // loads the pg codes, pages, and interaction events
  private obtenerFormularioDinamico(): void {
    const page = this.designerContext.product as PageType;
    this.getViewEngines().then(()=>
    {
      if (this.designerContext.page) {
        if (!this.isNonTransactional) {
          this.flowService
            .getDesignerConfiguration(
              page.codSistema,
              page.codNegocio,
              page.codProducto,
              page.flowId,
              page.documentKind,
              page.standardkey
            )
            .subscribe((res) => {
              this.designerContext.product.pageList = res.pages;
              this.designerContext.product.interactionRules = res.rules;
              this.designerContext.product.pgCodes = res.pgCodes;
              this.pageService.get(page).then((product) => {
                this.designerContext.product.attributeCodes = res.attributeCodes;
                this.obtenerCustomAtributos(product);
              });
            });
        } else {
          this.nonTransactionalSrv
            .getFlow(this.flowId, this.pageId)
            .subscribe((res) => {
              let response = {};
              res == null ? response = NonTransLayout: response = res;
              
              this.nonTransactionalSrv.getAll().subscribe((flows) => {
                response['isNonTransactional'] = true;
                response['flowList'] = flows;
                this.cargarDesigner(response);
              });
            });
          this.nonTransactionalSrv
            .getFlowPages(this.flowId)
            .subscribe((pages) => {
              this.designerContext.product.pageList = pages.map(
                (page) =>
                  <DesignerSelectItem>{
                    id: page.id,
                    description: page.id,
                  }
              );
            });
            this.nonTransactionalSrv.getNonTransactionalRules(this.flowId).subscribe((rules)=>
            {
              this.designerContext.product.interactionRules =[];
              rules.forEach(x=> {
                  const rr: DesignerSelectItem = {
                    id: x.name,
                    description: x.name
                  };
                  this.designerContext.product.interactionRules.push(rr);
                })
            });
            this.filterAttr();
        }
      } else {
        const contexto = this.designerContext.product as ProductType;
        this.formularioDinamicoService
          .getBySistema(
            contexto.codSistema,
            contexto.codNegocio,
            contexto.codProducto,
            contexto.codServicio,
            contexto.codComando,
            contexto.documentKind,
            contexto.listPath
          )
          .then((product) => {
            this.obtenerCustomAtributos(product);
          });
      }
    });
  }

  /**
   * Obtiene los custom atributos, basandose
   * al contexto
   */
  private obtenerCustomAtributos(product: ProductFlowService | PageType): void {
    const contexto = this.designerContext.product;
    this.formularioDinamicoService
      .getCustomAtributos(
        contexto.codSistema,
        contexto.codNegocio,
        contexto.codProducto,
        contexto.codServicio,
        contexto.codComando,
        contexto.documentKind,
        contexto.standardkey,
        contexto.listPath,
        this.flowId
      )
      .then((atributos) => {
        this.cargarDesigner(product);
        this.getProductServiceSuccess(atributos);
      });
  }

  private getViewEngines(): Promise<void>{
      return this.formularioDinamicoService.getViewEngines().then((viewEngines) => {
      this.viewEngines = viewEngines.map((viewEngine) => {
       return <ViewEngine> {
          codViewEngine: viewEngine.codViewEngine,
          moduleName: viewEngine.moduleName,
          title: viewEngine.title,
          outputs: this.formaDecorators(viewEngine.outputs),
          inputs: this.formaDecorators(viewEngine.inputs),
          configuration: JSON.parse(viewEngine.configuration),
        };
      });
      const dynamicTemplate = <ViewEngine> {
        codViewEngine: 'DYNAMICTEMPLATE',
        moduleName: 'SxDynamicTemplate',
        title: 'Dynamic Template | View Engine',
        outputs: {},
        inputs: {
          jsonAttribute: '',
          templatePath: ''
        },
        configuration: {},
      };
      this.viewEngines.unshift(dynamicTemplate)

      this.internalState.setViewEngines(this.viewEngines);
      return;
    });
  }

  private formaDecorators(decorators): Object {
    const formatedDecorators = {};
    for (const key in decorators) {
      formatedDecorators[decorators[key]] = {};
    }
    return formatedDecorators;
  }

  changedPanel(panel: string) {
    this.selected = panel;
  }

  private getOpcionesDragula() {
    return {
      copy: true,
      ignoreInputTextSelection: false,
      moves: (el, source, handle, sibling) => !el.classList.contains('no-drag'),
      accepts: (el, target, source, sibling) => {
        let accept = false;
        let element = target;

        let id = null;
        while (element != null && id == null) {
          id = element.getAttribute('data-designerType-id');
          element = element.parentElement;
        }

        // Solo acepto drop sobre designers.
        if (id) {
          accept = true;
        }

        return accept;
      },
    };
  }

  loadListValidators(item: any, option: any) {
    item.value = option.id;
    // Acepto la nueva configuracion
    if (this.designerContext.selectedDesignerAtts) {
      this.designerContext.selectedDesignerAtts.forEach((att) =>
        att.acceptChanges()
      );
    }
  }

  // If new designer page is selected, this goes back to the previous page
  // and opens the modal over the previously selected designer component
  loadFromStorage() {
    const desContx = this.cacheService.getDesignerOutputs();
    this.cacheService.removeDesignerOutputs();
    const inputs = this.cacheService.getDesignerInputs();
    this.cacheService.removeDesignerInputs();

    if (desContx != null && inputs != null) {
      const ref = this.mainContainer.getReferenceById(
        desContx.storedSelectionId
      );
      ref.attributes.find((x) => x.name === desContx.propertyName).value =
        inputs.storedRuleCode;
    }
  }

  isValid = (item :string) =>{
    return this.searchAtt ? 
    item
    .toString()
    .toUpperCase()
    .indexOf(this.searchAtt.toUpperCase()) !== -1 : false;
  }

  // Region Search
  filterAttr() {
    this.searchAtt = this.internalState.getCurrentFilterAttr();
    if (!this.searchAtt) {
      this.attFiltered = this.designerContext.externalControls;
      this.veFiltered = this.viewEngines;
    } else {
      this.attFiltered = this.designerContext.externalControls.filter(item => {
        if (item.codAtributo === 'LAYOUT') return false;
        let isValid = false;
        isValid = this.isValid(item.codAtributo);
        if (!isValid && item.tipoDato) 
          isValid = this.isValid(item.tipoDato);
        if ( !isValid && item.descripcion)
          isValid = this.isValid(item.descripcion);
        return isValid;      
      });

      this.veFiltered = this.viewEngines.filter(item => {
        let isValid = false;
        isValid = this.isValid(item.codViewEngine);
        if (!isValid && item.title) 
          isValid = this.isValid(item.title);
        if ( !isValid && item.moduleName)
          isValid = this.isValid(item.moduleName);
        return isValid;      
      });
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/main/designer.component.ts